import Api from './api.service'

import Configuration from '@/configuration';
const baseAdminURL = Configuration.value('apiBackend')

export default {
  getAll(query) {
    return Api().get(`${baseAdminURL}/merchant`, { params: query })
  },
  get(id) {
    return Api().get(`${baseAdminURL}/merchant/${id}`)
  },
  create(payload) {
    return Api().post(`${baseAdminURL}/merchant`, payload)
  },
  store(id, payload) {
    return Api().post(`${baseAdminURL}/merchant/${id}`, payload)
  },
  setStatus(id) {
    return Api().post(`${baseAdminURL}/merchant/status/${id}`)
  },
  delete(id) {
    return Api().delete(`${baseAdminURL}/merchant/${id}`)
  }
}
